// export const BASE_URL = "https://api.linktracker.pro";
// export const BASE_URL = process.env.BASE_URL;

export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:8000"
    : "https://api.linktracker.pro"; //.. production

// export const BASE_URL = "https://api.linktracker.pro";
